import React, { Component } from 'react';
import { connect } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { COLORS } from '../styles/colors';
import { duplicateWorkout } from "../store/actions/workouts";
import { duplicateProgram } from "../store/actions/programs";
import withAuth from '../hocs/withAuth';
import { ConfirmJsMessage } from '../helpers.js'

class DuplicateButton extends Component {

  duplicateItem() {
    const { duplicateWorkout, duplicateProgram, item, type } = this.props;
    if (ConfirmJsMessage(`Are you sure you want to duplicate the ${type}?`)) {
      const func = type === 'workout' ? duplicateWorkout : duplicateProgram;
      func(item._id).then((response) => {
        window.location.reload();
      });
    }
  }

  render() {
    const { item } = this.props;
    if (!item) return null;
    return (
      <div>
        <span
          className="link"
          onClick={() => {this.duplicateItem()}}
          style={{ float: 'right', marginRight: 2 }}>
          <FontAwesomeIcon icon={faCopy} title={"Copy"}
            style={{ marginRight: 5, color: COLORS.orange }} />
        </span>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
    return {
      errors: state.errors
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      duplicateWorkout: (data) => {
        return dispatch(duplicateWorkout(data));
      },
      duplicateProgram: (data) => {
        return dispatch(duplicateProgram(data));
      }
    }
  }

export default connect(mapStateToProps, mapDispatchToProps)(withAuth(DuplicateButton));



// WEBPACK FOOTER //
// ./src/components/DuplicateButton.js